<template>
  <div class="form-group centix-vue-boolinput row" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">

    <form-label v-if="!labelRight" :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
      <span class="holder-span" :class="inputCssClass">
        <bool-input ref="chkBox" v-model="localvalue" @value-changed="valueChanged" :is-enabled="isEnabled" :required="required" class="input-item"/>
      </span>

      <form-label v-if="labelRight" :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>
<script>
import boolinput from 'components/Input/BoolInput.vue';
import FormMixin from './formitem.js';

export default {
  mixins: [FormMixin],
  components: {
    'bool-input': boolinput
  },
  props: {
    value: {
      required: true
    },
    labelRight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formType: 'bool',
      localvalue: null
    };
  },
  mounted () {
    this.localvalue = this.value;
  },
  methods: {
    raiseValueChanged (val) {
      this.$emit('change', val);
      this.emitFormChange();
    },
    valueChanged (val) {
      this.$log('value changed from inner component', val);
      if (val !== this.value) {
        this.raiseValueChanged(val);
      }
    },
    clearForm() {
      this.raiseValueChanged('');
    },
    click() {
      if (this.isEnabled) {
        // toggle the checked state
        this.raiseValueChanged(!(this.value === true));
      }
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    validDate () {
      return true;
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.localvalue = newvalue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-boolinput {
  span.holder-span {
    position: relative;
    display: block;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }
      &.filled {
        padding-right: 25px;
        border: 2px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
</style>
